














































































































import { Component } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import { DetailItem } from "@/store/email/statistic/types";
import {LongTextWings, ScrollButton} from 'wings-ui-components';
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";
import EmailDetailFilter from "@/components/Email/EmailDetailFilter.vue";
import { dateFilter } from "@/utils/date-util";

@Component({ components: {EmailDetailFilter, ScrollButton, LongTextWings}, filters: {dateFilter} })
export default class EmailDetail extends BaseItemsPage<DetailItem> {

  @Getter("emailStatisticDetail") responseItems: any;

  is_show_filter_additional = false;
  currentSort = "create_date";

  tableFields = this.tableFieldsDefault;

  get tableFieldsDefault() {
    return [
      "create_date",
      "originator",
      "recipient",
      "subject",
      "status",
      "partner_price",
      "detail"
    ];
  }

  getData() {
    return this.responseItems;
  }

}
